import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'moment-timezone';
import { environment } from './environments/environment';
import './polyfills';
import { RootModule } from './root.module';

if ('serviceWorker' in navigator) {
  const hostname = location.hostname.toLowerCase();
  let isFromWebfacing = hostname === environment.WebFacingHost.toLowerCase();
  if (!environment.production) {
    // DEV: register your custom dev-sw
    navigator.serviceWorker.getRegistrations().then(regs => {
      regs.forEach(reg => {
        if (reg.active && reg.active.scriptURL.includes('ngsw-worker.js')) {
          reg.unregister();
        }
      });
    });

    if (!isFromWebfacing) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/dev-sw.js')
          .then(reg => {
            console.log('Dev SW registered:', reg);
          })
          .catch(err => console.error('Dev SW registration failed:', err));
      });
    }
  }
  else if (isFromWebfacing) {
    navigator.serviceWorker.getRegistrations().then(regs => {
      regs.forEach(reg => {
        if (reg.active && reg.active.scriptURL.includes('ngsw-worker.js')) {
          reg.unregister();
        }
      });
    });
  }
  // 👉 In production do nothing, Angular will auto-register ngsw-worker.js
}

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => {
  return platformBrowserDynamic().bootstrapModule(RootModule);
};

/* "Hot Module Replacement" is enabled as described on
 * https://medium.com/@beeman/tutorial-enable-hrm-in-angular-cli-apps-1b0d13b80130#.sa87zkloh
 */
bootstrap(); //Regular bootstrap
